module.exports = __webpack_public_path__ + "static/media/27OCHA9.f09c8108.jpg";